<template>
  <el-dropdown trigger="click" class="vc-middle">
    <div v-if="user" class="box-image cursor-pointer">
      <avatar
        :class="{ facebook: user.from == 'faceBook' && user.profileImg == '' }"
        :rounded="false"
        :username="`${user.nameTH}`"
        :src="
          user.profileImg
            ? `${urlImage}${user.userId}/${user.profileImg}`
            : user.from == 'faceBook' && user.profileImg == ''
            ? `https://graph.facebook.com/${user.profileFrom}/picture?type=small`
            : `${user.profileFrom}`
        "
        :size="imageSize"
      ></avatar>
    </div>
    <el-dropdown-menu v-if="user" slot="dropdown" class="menu-user-box">
      <div class="pd-x-4">
        <div
          class="flex-display flex-column ai-center js-center border-b pd-y-4"
        >
          <div
            @click="$router.push('/profile').catch(() => {})"
            class="position-relative cursor-pointer"
          >
            <div class="box-image">
              <avatar
                :class="{
                  facebook: user.from == 'faceBook' && user.profileImg == '',
                }"
                :rounded="false"
                :username="
                  typeof user.nameTH != 'undefined'
                    ? `${user.nameTH}`
                    : user.email
                "
                :src="
                  user.profileImg
                    ? `${urlImage}${user.userId}/${user.profileImg}`
                    : user.from == 'faceBook' && user.profileImg == ''
                    ? `https://graph.facebook.com/${user.profileFrom}/picture?type=large`
                    : `${user.profileFrom}`
                "
                :size="60"
              ></avatar>
            </div>
            <div class="color-bg-secondary icon-edit">
              <i class="fas fa-pen"></i>
            </div>
          </div>
          <h4 class="text-font-14">
            {{
              typeof user.nameTH != "undefined"
                ? `${user.nameTH} ${user.surnameTH}`
                : user.email
            }}
          </h4>
        </div>
        <MenuStudent v-if="user.role == 0 && haveUserData" />
        <MenuAdmin v-if="(user.role == 50 || user.role == 60 || user.role == 80)" />

        <div class="pd-t-5">
          <p @click="signout" class="text-font-12 color-gray mg-y-4">
            <i class="fas fa-sign-out-alt"></i>
            ออกจากระบบ
          </p>
        </div>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Avatar from "vue-avatar";
import MenuStudent from "./MenuStudent";
import MenuAdmin from "./MenuAdmin";

export default {
  components: {
    Avatar,
    MenuStudent,
    MenuAdmin,
  },
  props: {
    imageSize: {
      type: Number,
      default() {
        return 30;
      },
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    haveUserData() {
      return this.$store.state.haveUserData;
    },
  },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
    };
  },
  methods: {
    signout() {
      this.$store.commit("SIGNOUT");
      this.$router.push({ path: "/" }).catch(() => {
        window.location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.icon-edit {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: $--color-secondary;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: #fff;
}
</style>